/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import intl from 'react-intl-universal';

import { scoreDecimals } from "../../helpers/IspScoreHelper";

import { getCountryName } from "../place/GeoCountries";
import ScoreIndicator from "../../components/ScoreIndicator";
import IspRankSummary from "./IspRankSummary";

class IspCard extends Component {


    isp() {
        return this.props.isp;
    }

    shouldShowSpeed() {
        return !this.props.show || this.props.show === 0;
    }

    shouldShowRating() {
        return this.props.show === 1;
    }

    shouldShowDistribution() {
        return this.props.show === 2;
    }

    shouldShowRank() {
        return this.props.rank > 0;
    }

    shouldShowSpeedDetails() {
        return !this.props.showSpeedDetails || this.props.showSpeedDetails === true;
    }

    render() {
        const isp = this.isp();

        return (
            <div className={this.props.className}>
                <div className="card-body p-4">
                    {this.renderRank()}
                    <div className="text-center">
                        <Link to={this.getIspDeepLink()}>
                            <div className="lg-avatar mx-auto mb-3">
                                <img className="img-fluid d-inline-block rounded-square" src={isp.logoImageUrl} width="96"
                                    height="96" alt={isp.name + ' logo'} />
                            </div>
                            <h1 className="h5">{isp.name}</h1>

                            {this.renderScore(isp)}
                        </Link>

                    </div>
                </div>
                {this.renderSpeedDetails(isp)}
            </div>
        );
    }

    renderSpeedDetails(isp) {
        if (!this.shouldShowSpeedDetails())
            return;

        const download = isp.ispScore.averageDownloadSpeed.toFixed(1);
        const upload = isp.ispScore.averageUploadSpeed.toFixed(1);

        return (
            <div className="card-footer text-center py-4">
                <div className="row align-items-center">
                    <div className="col-6">
                        <h2 className="small text-secondary mb-0">{intl.getHTML('generic_download_speed')}</h2>
                        <small className="fas fa-arrow-down text-secondary align-middle mr-1" />
                        <span className="align-middle">{download}</span>
                    </div>
                    <div className="col-6 column-divider">
                        <h3 className="small text-secondary mb-0">{intl.getHTML('generic_upload_speed')}</h3>
                        <small className="fas fa-arrow-up text-secondary align-middle mr-1" />
                        <span className="align-middle">{upload}</span>
                    </div>
                </div>
            </div>);
    }

    renderRank() {
        if (!this.shouldShowRank())
            return;

        const rank = this.props.rank;
        return (
            <div className="row justify-content-between align-items-center mb-2">
                <div className="col text-right">
                    <a className={`small ${rank === 1 ? "text-body" : "text-muted"}`} href="/#">
                        {
                            rank === 1 && <span className="fas fa-trophy text-body mr-1" />
                        }
                        {
                            (rank === 2 || rank === 3) && <span className="fas fa-trophy text-muted mr-1" />
                        }
                        #{rank}
                    </a>
                </div>
            </div>
        );
    }

    getIspDeepLink() {
        const isp = this.isp();
        if (isp.countryRegion) {
            return '/provider/' + isp.id + '/' + getCountryName(isp.countryCode) + '/' + isp.countryRegion +
                (isp.countryCity ? '/' + isp.countryCity : '');
        } else {
            return '/provider/' + isp.id + '/' + getCountryName(isp.countryCode) +
                (isp.countryCity ? '/all/' + isp.countryCity : '');
        }
    }

    renderScore(isp) {
        if (this.shouldShowSpeed()) {
            const scoreValue = isp.ispScore.scoreValue;
            let score = scoreDecimals(scoreValue / (100.0 / 5), 1);

            return (
                <div className="mb-2">
                    <ScoreIndicator score={scoreValue} />
                    <span className="font-weight-semi-bold ml-2">{score}</span>
                    <div>
                        <IspRankSummary isp={isp} score={scoreValue} />
                    </div>
                </div>
            )
        }

        if (this.shouldShowRating()) {
            const sentimentValue = isp.ispSentiment.sentimentValue;
            let sentiment = scoreDecimals(sentimentValue / (100.0 / 5), 1);

            return (
                <div className="mb-2">
                    <ScoreIndicator score={sentimentValue}
                        fullClass="fas fa-heart"
                        halfClass="fas fa-heart"
                        emptyClass="far fa-heart" />
                    <span className="font-weight-semi-bold ml-2">{sentiment}</span>
                    <div>
                        <IspRankSummary isp={isp} score={sentimentValue} />
                    </div>
                </div>
            )
        }

        if (this.shouldShowDistribution()) {
            const sampleValue = isp.ispScore.samples;
            return (
                <div className="mb-2">
                    <div className="font-weight-semi-bold ml-2">{sampleValue}</div>
                    <small className="text-muted">{intl.get('isp_speed_test_sources')}</small>
                </div>
            )
        }

    }
}

export default IspCard;